import React from 'react'
import { IDashboard, IWidget } from '@/pages/Dashboards/dashboards.types.ts'
import { CardMoveType } from '@/pages/Dashboards/services/autoalign/autoalign.types.ts'
import LastValuesWidgetCard from '@/pages/Dashboards/pages/DashboardScreen/WidgetCard/LastValuesWidgetCard'
import IntervalValuesWidgetCard from '@/pages/Dashboards/pages/DashboardScreen/WidgetCard/IntervalValuesWidgetCard'

interface IProps {
  dashboardId: IDashboard['id']
  component: IWidget
  onMove: (position: IWidget, type: CardMoveType) => void
  onMoveFinish: () => void
  viewport: number
}

const WidgetCard = (props: IProps) => {
  if (['text', 'svg', 'table'].includes(props.component.type)) {
    return <LastValuesWidgetCard {...props} />
  }

  return <IntervalValuesWidgetCard {...props} />
}

export default React.memo(WidgetCard)
